<div class="snackbar-group-wrapper">
  <div class="snackbar-group">
    @for (notification of notifications$ | async; track $index) {
      @if (notification.display) {
        <payments-snackbar class="grouped-snackbar" [notification]="notification">
        </payments-snackbar>
      }
    }
  </div>
</div>
